import React from 'react';

import AppBar from '@mui/material/AppBar';
import { styled } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';

import { ReactComponent as FlipdishLogo } from '../../assets/images/FlipdishLogo.svg';
import AppLessUserMenu from './AppLessUserMenu';

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  borderBottom: `1px solid ${theme.palette.divider}`,
  boxShadow: 'none',
}));

const StyledToolbar = styled(Toolbar)({
  display: 'flex',
  justifyContent: 'space-between',
});

const StyledLogoWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
});

const AppLessTopBar = () => {
  return (
    <StyledAppBar
      color="default"
      data-fd="no-organisation-access-topbar"
      enableColorOnDark
      position="static"
    >
      <StyledToolbar>
        <StyledLogoWrapper data-fd="no-organisation-access-logo">
          <FlipdishLogo />
        </StyledLogoWrapper>
        <AppLessUserMenu />
      </StyledToolbar>
    </StyledAppBar>
  );
};

export default AppLessTopBar;
